import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { FaBrain, FaBone, FaClock } from "react-icons/fa";
import "./PriseEnChargeTable.css";

function OptionExclusionCondGen() {
  const context = useContext(AppContext);

  return (
    <>
      <div className="prise-en-charge-container">
        <Column fill>
          <CardBox>
            <Column fill>
            <Row>
              <DropDown
                label="Prise en charge des affections psychiatriques et psychiques"
                icon={<FaBrain />}
                value={context.state.PECPsy}
                onChange={context.handleInputChange("PECPsy")}
                options={[
                  { value: "Non", label: "Non" },
                  { value: "Oui", label: "Oui" },
                  { value: "Non communiqué", label: "Non communiqué" },
                ]}
                xxlarge
              />
            </Row>
            {context.state.PECPsy === "Oui" && (
              <Row>
                <div className="prise-en-charge-table-container">
                  <table className="mono">
                    <tbody>
                      <tr>
                        <td>
                          <label className="prise-en-charge-cell-label">Délai de carence</label>
                          <DropDown
                            value={context.state.PECPsyCarence}
                            onChange={context.handleInputChange("PECPsyCarence")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "0", label: "Aucun" },
                              { value: "90", label: "90 jours" },
                              { value: "180", label: "180 jours" },
                              { value: "365", label: "365 jours" },
                            ]}
                          />
                        </td>
                        <td>
                          <label className="prise-en-charge-cell-label">Condition de prise en charge</label>
                          <DropDown
                            value={context.state.PECPsyDureeHospi}
                            onChange={context.handleInputChange("PECPsyDureeHospi")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "0", label: "Sans condition d'hospitalisation" },
                              { value: "7", label: "Sans condition mais franchise minimale de 30 jours" },
                              { value: "10", label: "Sans condition mais franchise minimale de 60 jours" },
                              { value: "8", label: "Sans condition mais franchise minimale de 90 jours" },
                              { value: "1", label: "3 jours en service psy ou 8 jours ailleurs" },
                              { value: "12", label: "5 jours en service psy ou 8 jours ailleurs" },
                              { value: "11", label: "Hospitalisation de 1 jour" },
                              { value: "9", label: "Hospitalisation de 3 jours" },
                              { value: "2", label: "Hospitalisation de 5 jours" },
                              { value: "13", label: "Hospitalisation de 5 jours en maladie et 15 jours en invalidité" },
                              { value: "3", label: "Hospitalisation de 8 jours" },
                              { value: "4", label: "Hospitalisation de 10 jours" },
                              { value: "5", label: "Hospitalisation de 14 jours" },
                              { value: "6", label: "Hospitalisation de 15 jours" },
                            ]}
                          />
                        </td>
                        <td>
                          <label className="prise-en-charge-cell-label">Durée de versement</label>
                          <DropDown
                            value={context.state.PECPsyDureeIJ}
                            onChange={context.handleInputChange("PECPsyDureeIJ")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "4", label: "Durée de l'hospitalisation" },
                              { value: "0", label: "365 jours" },
                              { value: "1", label: "365 jours sauf intervention chirurgicale" },
                              { value: "2", label: "365 jours sauf hospitalisation de + de 7 jours" },
                              { value: "3", label: "1095 jours" },
                            ]}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Row>
            )}
            <Row tpad>
              <DropDown
                label="Prise en charge des pathologies liées au dos"
                icon={<FaBone />}
                value={context.state.PECDos}
                onChange={context.handleInputChange("PECDos")}
                options={[
                  { value: "Non", label: "Non" },
                  { value: "Oui", label: "Oui" },
                  { value: "Non communiqué", label: "Non communiqué" },
                ]}
                 xxlarge
              />
            </Row>
            {context.state.PECDos === "Oui" && (
              <Row>
                <div className="prise-en-charge-table-container">
                  <table className="mono">
                    <tbody>
                      <tr>
                        <td>
                          <label className="prise-en-charge-cell-label">Délai de carence</label>
                          <DropDown
                            value={context.state.PECDosCarence}
                            onChange={context.handleInputChange("PECDosCarence")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "0", label: "Aucun" },
                              { value: "90", label: "90 jours" },
                              { value: "180", label: "180 jours" },
                              { value: "365", label: "365 jours" },
                            ]}
                          />
                        </td>
                        <td>
                          <label className="prise-en-charge-cell-label">Condition de prise en charge</label>
                          <DropDown
                            value={context.state.PECDosDureeHospi}
                            onChange={context.handleInputChange("PECDosDureeHospi")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "0", label: "Sans condition d'hospitalisation" },
                              { value: "6", label: "Sans condition mais franchise minimale de 30 jours" },
                              { value: "9", label: "Sans condition mais franchise minimale de 60 jours" },
                              { value: "7", label: "Sans condition mais franchise minimale de 90 jours" },
                              { value: "8", label: "Couvert si une intervention chirurgicale est nécessaire" },
                              { value: "1", label: "Hospitalisation de 24h" },
                              { value: "2", label: "Hospitalisation de 24h ou intervention chirurgicale" },
                              { value: "3", label: "Hospitalisation de 48h" },
                              { value: "4", label: "Hospitalisation de 48h ou intervention chirurgicale" },
                              { value: "5", label: "Hospitalisation de 7 jours" },
                            ]}
                          />
                        </td>
                        <td>
                          <label className="prise-en-charge-cell-label">Durée de versement</label>
                          <DropDown
                            value={context.state.PECDosDureeIJ}
                            onChange={context.handleInputChange("PECDosDureeIJ")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "0", label: "365 jours" },
                              { value: "1", label: "365 jours sauf intervention chirurgicale" },
                              { value: "4", label: "365 jours sauf inter. chir. avec hosp. d'au moins 7 jours" },
                              { value: "2", label: "365 jours sauf hospitalisation de + de 48h" },
                              { value: "3", label: " 1095 jours" },
                            ]}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Row>
            )}
            <Row tpad>
              <DropDown
                label="Prise en charge du temps partiel thérapeutique"
                icon={<FaClock />}
                value={context.state.MiTempsTherapeutique}
                onChange={context.handleInputChange("MiTempsTherapeutique")}
                options={[
                  { value: "Non", label: "Non" },
                  { value: "Oui", label: "Oui" },
                  { value: "Non communiqué", label: "Non communiqué" },
                ]}
                 xxlarge
              />
            </Row>

            {context.state.MiTempsTherapeutique === "Oui" && (
              <Row>
                <div className="prise-en-charge-table-container">
                  <table className="mono">
                    <tbody>
                      <tr>
                        <td>
                          <label className="prise-en-charge-cell-label">Délai de carence</label>
                          <DropDown
                            value={context.state.MTPCarence}
                            onChange={context.handleInputChange("MTPCarence")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "0", label: "Aucun" },
                              { value: "90", label: "90 jours" },
                              { value: "180", label: "180 jours" },
                              { value: "365", label: "365 jours" },
                            ]}
                          />
                        </td>
                        <td>
                          <label className="prise-en-charge-cell-label">Durée de versement</label>
                          <DropDown
                            value={context.state.MTPDureeIJ}
                            onChange={context.handleInputChange("MTPDureeIJ")}
                            options={[
                              { value: "NC", label: "Non communiqué" },
                              { value: "60", label: "60 jours" },
                              { value: "90", label: "90 jours" },
                              { value: "120", label: "120 jours" },
                              { value: "180", label: "180 jours" },
                              { value: "365", label: "365 jours" },
                              { value: "1095", label: "1095 jours" },
                            ]}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Row>
            )}
          </Column>
        </CardBox>
      </Column>
      </div>
    </>
  );
}

export default OptionExclusionCondGen;
